import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var ChevronLeft = function ChevronLeft(props) {
  useDeprecatedComponentWarning({
    component: 'ChevronLeft'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M329 158l-98 98 98 98-30 30-128-128 128-128z"
  }));
};

ChevronLeft.displayName = 'ChevronLeft';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  ChevronLeft.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default ChevronLeft;